import React from "react";
import axiosInstance from "./axiosInstance";
import useSWR, { mutate } from "swr";

let initInFlight = null;

export async function initCompany() {
  if (!initInFlight) {
    initInFlight = axiosInstance
      .post("/company")
      .finally(() => {
        initInFlight = null;
      });
  }
  return initInFlight;
}

export const useCompany = () => {
  const result = useSWR("/company");
  const tried = React.useRef(false);
  React.useEffect(() => {
    const status =
      result.error && result.error.response && result.error.response.status;
    if (status === 404 && !tried.current) {
      tried.current = true;
      initCompany()
        .then(() => mutate("/company"))
        .catch(() => {});
    }
  }, [result.error]);
  return result;
};

export async function getCompanies() {
  return await axiosInstance.get("/company?all=true");
}

export async function subscribe() {
  return await axiosInstance.post("/subscribe");
}

export const useConfig = () => {
  return useSWR("/config-public");
};
